module.exports = __webpack_public_path__ + "img/blshj02_center_003.b22b3030.png";